import React from "react";

const Disclamer = () => {
  return (
    <>
      <div className="content_2_advantages_wrapper">
        <div>
          <header>
            <h3>Disclaimer</h3>
            <h2>
              Enter the realm of fantasy cricket with aufantasy! Create your
              dream team, compete in thrilling leagues, and experience cricket
              like never before. aufantasy blends strategy, passion, and
              competition to deliver an unmatched fantasy sports adventure. Our
              platform is dedicated to ensuring a secure and fair gaming
              environment while complying with all relevant laws and
              regulations. Important Note: Fantasy sports may not be available
              in certain regions, including Andhra Pradesh, Assam, Nagaland,
              Odisha, Sikkim, and Telangana. Access to aufantasy is restricted
              to users aged 18 and above. Play responsibly and take your fantasy
              cricket experience to the next level with aufantasy
            </h2>
          </header>
          <div className="content_2_advantages_grid"></div>
        </div>
      </div>
    </>
  );
};

export default Disclamer;
